/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cf28017e4c52dc92f3b9d8ffa77c0af4>>
 * @codegenCommand yarn build tokens
 */

type TokenValue =
	| string;

type TokenValueOriginal =
	| string;

type TokenAttributes = {
	group: string;
	state: string;
	introduced: string;
	description: string;
	suggest?: string[];
	deprecated?: string;
	replacement?: string;
};


type Token = {
	value: TokenValue;
	filePath: string;
	isSource: boolean;
	attributes: TokenAttributes;
	original: {
		value: TokenValueOriginal;
		attributes: TokenAttributes;
	};
	name: string;
	path: string[];
	cleanName: string;
};

const tokens: Token[] = [
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "introduced": "0.12.0",
      "description": "Equates to `0`. Use for resetting default spacing styles."
    },
    "value": "0px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "introduced": "0.12.0",
        "description": "Equates to `0`. Use for resetting default spacing styles."
      },
      "value": "Space0"
    },
    "name": "space.0",
    "path": [
      "space",
      "0"
    ],
    "cleanName": "space.0"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "1px",
        "3px"
      ],
      "introduced": "0.12.0",
      "description": "Use for small and compact pieces of UI."
    },
    "value": "2px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "1px",
          "3px"
        ],
        "introduced": "0.12.0",
        "description": "Use for small and compact pieces of UI."
      },
      "value": "Space025"
    },
    "name": "space.025",
    "path": [
      "space",
      "025"
    ],
    "cleanName": "space.025"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "3px",
        "5px"
      ],
      "introduced": "0.12.0",
      "description": "Use for small and compact pieces of UI."
    },
    "value": "4px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "3px",
          "5px"
        ],
        "introduced": "0.12.0",
        "description": "Use for small and compact pieces of UI."
      },
      "value": "Space050"
    },
    "name": "space.050",
    "path": [
      "space",
      "050"
    ],
    "cleanName": "space.050"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "5px",
        "7px"
      ],
      "introduced": "0.12.0",
      "description": "Use for small and compact pieces of UI."
    },
    "value": "6px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "5px",
          "7px"
        ],
        "introduced": "0.12.0",
        "description": "Use for small and compact pieces of UI."
      },
      "value": "Space075"
    },
    "name": "space.075",
    "path": [
      "space",
      "075"
    ],
    "cleanName": "space.075"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "7px",
        "9px"
      ],
      "introduced": "0.12.0",
      "description": "Use for small and compact pieces of UI."
    },
    "value": "8px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "7px",
          "9px"
        ],
        "introduced": "0.12.0",
        "description": "Use for small and compact pieces of UI."
      },
      "value": "Space100"
    },
    "name": "space.100",
    "path": [
      "space",
      "100"
    ],
    "cleanName": "space.100"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "10px",
        "11px",
        "13px",
        "14px"
      ],
      "introduced": "0.12.0",
      "description": "Use for larger and less dense pieces of UI."
    },
    "value": "12px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "10px",
          "11px",
          "13px",
          "14px"
        ],
        "introduced": "0.12.0",
        "description": "Use for larger and less dense pieces of UI."
      },
      "value": "Space150"
    },
    "name": "space.150",
    "path": [
      "space",
      "150"
    ],
    "cleanName": "space.150"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "14px",
        "15px",
        "17px",
        "18px"
      ],
      "introduced": "0.12.0",
      "description": "Use for larger and less dense pieces of UI."
    },
    "value": "16px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "14px",
          "15px",
          "17px",
          "18px"
        ],
        "introduced": "0.12.0",
        "description": "Use for larger and less dense pieces of UI."
      },
      "value": "Space200"
    },
    "name": "space.200",
    "path": [
      "space",
      "200"
    ],
    "cleanName": "space.200"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "19px",
        "21px",
        "22px",
        "23px"
      ],
      "introduced": "0.12.0",
      "description": "Use for larger and less dense pieces of UI."
    },
    "value": "20px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "19px",
          "21px",
          "22px",
          "23px"
        ],
        "introduced": "0.12.0",
        "description": "Use for larger and less dense pieces of UI."
      },
      "value": "Space250"
    },
    "name": "space.250",
    "path": [
      "space",
      "250"
    ],
    "cleanName": "space.250"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "23px",
        "25px",
        "26px",
        "27px",
        "28px"
      ],
      "introduced": "0.12.0",
      "description": "Use for larger and less dense pieces of UI."
    },
    "value": "24px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "23px",
          "25px",
          "26px",
          "27px",
          "28px"
        ],
        "introduced": "0.12.0",
        "description": "Use for larger and less dense pieces of UI."
      },
      "value": "Space300"
    },
    "name": "space.300",
    "path": [
      "space",
      "300"
    ],
    "cleanName": "space.300"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "28px",
        "29px",
        "30px",
        "31px",
        "33px",
        "34px",
        "35px"
      ],
      "introduced": "0.12.0",
      "description": "Use for the largest pieces of UI and for layout elements."
    },
    "value": "32px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "28px",
          "29px",
          "30px",
          "31px",
          "33px",
          "34px",
          "35px"
        ],
        "introduced": "0.12.0",
        "description": "Use for the largest pieces of UI and for layout elements."
      },
      "value": "Space400"
    },
    "name": "space.400",
    "path": [
      "space",
      "400"
    ],
    "cleanName": "space.400"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "introduced": "0.12.0",
      "description": "Use for the largest pieces of UI and for layout elements."
    },
    "value": "40px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "introduced": "0.12.0",
        "description": "Use for the largest pieces of UI and for layout elements."
      },
      "value": "Space500"
    },
    "name": "space.500",
    "path": [
      "space",
      "500"
    ],
    "cleanName": "space.500"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "introduced": "0.12.0",
      "description": "Use for the largest pieces of UI and for layout elements."
    },
    "value": "48px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "introduced": "0.12.0",
        "description": "Use for the largest pieces of UI and for layout elements."
      },
      "value": "Space600"
    },
    "name": "space.600",
    "path": [
      "space",
      "600"
    ],
    "cleanName": "space.600"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "introduced": "0.12.0",
      "description": "Use for the largest pieces of UI and for layout elements."
    },
    "value": "64px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "introduced": "0.12.0",
        "description": "Use for the largest pieces of UI and for layout elements."
      },
      "value": "Space800"
    },
    "name": "space.800",
    "path": [
      "space",
      "800"
    ],
    "cleanName": "space.800"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "introduced": "0.12.0",
      "description": "Use for the largest pieces of UI and for layout elements."
    },
    "value": "80px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "introduced": "0.12.0",
        "description": "Use for the largest pieces of UI and for layout elements."
      },
      "value": "Space1000"
    },
    "name": "space.1000",
    "path": [
      "space",
      "1000"
    ],
    "cleanName": "space.1000"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "-1px",
        "-3px"
      ],
      "introduced": "1.21.0",
      "description": "Use to negate parent whitespace or overlap small pieces of UI."
    },
    "value": "-2px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "-1px",
          "-3px"
        ],
        "introduced": "1.21.0",
        "description": "Use to negate parent whitespace or overlap small pieces of UI."
      },
      "value": "SpaceNegative025"
    },
    "name": "space.negative.025",
    "path": [
      "space",
      "negative",
      "025"
    ],
    "cleanName": "space.negative.025"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "-3px",
        "-5px"
      ],
      "introduced": "1.21.0",
      "description": "Use to negate parent whitespace or overlap small pieces of UI."
    },
    "value": "-4px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "-3px",
          "-5px"
        ],
        "introduced": "1.21.0",
        "description": "Use to negate parent whitespace or overlap small pieces of UI."
      },
      "value": "SpaceNegative050"
    },
    "name": "space.negative.050",
    "path": [
      "space",
      "negative",
      "050"
    ],
    "cleanName": "space.negative.050"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "-5px",
        "-7px"
      ],
      "introduced": "1.21.0",
      "description": "Use to negate parent whitespace or overlap small pieces of UI."
    },
    "value": "-6px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "-5px",
          "-7px"
        ],
        "introduced": "1.21.0",
        "description": "Use to negate parent whitespace or overlap small pieces of UI."
      },
      "value": "SpaceNegative075"
    },
    "name": "space.negative.075",
    "path": [
      "space",
      "negative",
      "075"
    ],
    "cleanName": "space.negative.075"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "-7px",
        "-9px"
      ],
      "introduced": "1.21.0",
      "description": "Use to negate parent whitespace or overlap small pieces of UI."
    },
    "value": "-8px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "-7px",
          "-9px"
        ],
        "introduced": "1.21.0",
        "description": "Use to negate parent whitespace or overlap small pieces of UI."
      },
      "value": "SpaceNegative100"
    },
    "name": "space.negative.100",
    "path": [
      "space",
      "negative",
      "100"
    ],
    "cleanName": "space.negative.100"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "-10px",
        "-11px",
        "-13px",
        "-14px"
      ],
      "introduced": "1.21.0",
      "description": "Use to negate parent whitespace or overlap larger pieces of UI."
    },
    "value": "-12px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "-10px",
          "-11px",
          "-13px",
          "-14px"
        ],
        "introduced": "1.21.0",
        "description": "Use to negate parent whitespace or overlap larger pieces of UI."
      },
      "value": "SpaceNegative150"
    },
    "name": "space.negative.150",
    "path": [
      "space",
      "negative",
      "150"
    ],
    "cleanName": "space.negative.150"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "-14px",
        "-15px",
        "-17px",
        "-18px"
      ],
      "introduced": "1.21.0",
      "description": "Use to negate parent whitespace or overlap larger pieces of UI."
    },
    "value": "-16px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "-14px",
          "-15px",
          "-17px",
          "-18px"
        ],
        "introduced": "1.21.0",
        "description": "Use to negate parent whitespace or overlap larger pieces of UI."
      },
      "value": "SpaceNegative200"
    },
    "name": "space.negative.200",
    "path": [
      "space",
      "negative",
      "200"
    ],
    "cleanName": "space.negative.200"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "-19px",
        "-21px",
        "-22px",
        "-23px"
      ],
      "introduced": "1.21.0",
      "description": "Use to negate parent whitespace or overlap larger pieces of UI."
    },
    "value": "-20px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "-19px",
          "-21px",
          "-22px",
          "-23px"
        ],
        "introduced": "1.21.0",
        "description": "Use to negate parent whitespace or overlap larger pieces of UI."
      },
      "value": "SpaceNegative250"
    },
    "name": "space.negative.250",
    "path": [
      "space",
      "negative",
      "250"
    ],
    "cleanName": "space.negative.250"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "-23px",
        "-25px",
        "-26px",
        "-27px",
        "-28px"
      ],
      "introduced": "1.21.0",
      "description": "Use to negate parent whitespace or overlap larger pieces of UI."
    },
    "value": "-24px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "-23px",
          "-25px",
          "-26px",
          "-27px",
          "-28px"
        ],
        "introduced": "1.21.0",
        "description": "Use to negate parent whitespace or overlap larger pieces of UI."
      },
      "value": "SpaceNegative300"
    },
    "name": "space.negative.300",
    "path": [
      "space",
      "negative",
      "300"
    ],
    "cleanName": "space.negative.300"
  },
  {
    "attributes": {
      "group": "spacing",
      "state": "active",
      "suggest": [
        "-28px",
        "-29px",
        "-30px",
        "-31px",
        "-33px",
        "-34px",
        "-35px"
      ],
      "introduced": "1.21.0",
      "description": "Use to negate parent whitespace or overlap the largest pieces of UI."
    },
    "value": "-32px",
    "filePath": "schema/themes/atlassian-spacing/spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "spacing",
        "state": "active",
        "suggest": [
          "-28px",
          "-29px",
          "-30px",
          "-31px",
          "-33px",
          "-34px",
          "-35px"
        ],
        "introduced": "1.21.0",
        "description": "Use to negate parent whitespace or overlap the largest pieces of UI."
      },
      "value": "SpaceNegative400"
    },
    "name": "space.negative.400",
    "path": [
      "space",
      "negative",
      "400"
    ],
    "cleanName": "space.negative.400"
  }
];

export default tokens;
